import { useEffect } from "react";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import ReactGA from 'react-ga4';
import { BrowserView, MobileView } from "react-device-detect";
import { RecitationSubmissionWeb } from './RecitationSubmissionWeb';
import { RecitationSubmissionMobile } from './RecitationSubmissionMobile';

const RecitationSubmission = () => {
  const gaEventTracker = useAnalyticsEventTracker("Invoice");
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Recitation Submission",
    });
  }, []);
  return (
    <>
      <BrowserView>
        <RecitationSubmissionWeb/>
      </BrowserView>
      <MobileView>
        <RecitationSubmissionMobile/>
      </MobileView>
    </>
  );
}

export default RecitationSubmission;